import * as React from 'react';
import { UIText1 } from '@cian/ui-kit/typography';
import { InlineButton } from '../InlineButton';

export interface IChangePhoneProps {
  phone: string;

  onChangeClick(): void;
}

export const ChangePhone: React.FC<React.PropsWithChildren<IChangePhoneProps>> = ({ phone, onChangeClick }) => {
  return (
    <div>
      <UIText1>Введите код, который мы отправили на номер {phone} </UIText1>
      <InlineButton onClick={onChangeClick}>Изменить номер</InlineButton>
    </div>
  );
};

ChangePhone.displayName = 'ChangePhone';
